import { PATHS } from "@constants/Paths";
export const communityPath = (communityId) => PATHS.COMMUNITY.replace(":communityId", communityId);
export const reportPath = (assessmentId) => PATHS.OVERVIEW.replace(":assessmentId", assessmentId);
export const topicsAndSourcesPath = (assessmentId) => PATHS.RESULTS.replace(":assessmentId", assessmentId);
